import FormComponent from "../../common/FormComponent";
import React from "react";
import { bindActionCreators } from "redux";
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import Grid from "@material-ui/core/Grid";
import { Paper } from "@material-ui/core";
import strings from "../../localization";
import Validators from "../../constants/ValidatorTypes";
import { withSnackbar } from "notistack";
import { editCremationStatement, getCremationStatementById } from "../../services/cremationStatement/CremationStatementService";
import CremationStatementForm from "../../components/forms/cremationStatement/CremationStatementForm";
import { getPostalCodesImproved } from "../../services/postalCodeImproved/PostalCodeImprovedService";
import { getStates } from "../../services/state/StateService";
import { getGraveSiteById, getGraveSitesWithSelectedGraveyard } from "../../services/graveSite/GraveSiteService";
import { getGraveyardById, getGraveyards } from "../../services/graveyard/GraveyardService";

class EditCremationStatement extends FormComponent {

    validationList = {
        fullName: [{ type: Validators.REQUIRED }],
        jmbg: [{ type: Validators.REQUIRED }],
        phoneNumber: [{ type: Validators.REQUIRED }],
        comments: [{ type: Validators.REQUIRED }],
        referenceNumber: [{ type: Validators.REQUIRED }],
    };

    constructor(props) {
        super(props);

        this.state = {
            data: props.data ? props.data : {},
            errors: {}
        };

        this.props.changeFullScreen(false);
        this.submit = this.submit.bind(this);
    }

    onAutocompleteChange = (event, values) => {
        let autocompleteName = event.target.id.split("-")[0];
        
        // Handle clearing of graveyard and gravesite
        if (autocompleteName === "graveyard" && !values) {
            this.setState({
                data: {
                    ...this.state.data,
                    graveyard: null,
                    graveSite: null,
                    graveyardId: null,
                    graveSiteId: null
                },
                graveSites: null
            });
        } 
        else if (autocompleteName === "graveSite" && !values) {
            this.setState({
                data: {
                    ...this.state.data,
                    graveSite: null,
                    graveSiteId: null
                }
            });
        }
        else {
            this.setState({
                data: {
                    ...this.state.data,
                    [autocompleteName]: values
                }
            });
        }
    }

    handleTextInputChange = (e) => {
        if (e.target.name === "state" && e.target.value.trim().length >= 2) {
            let data = {
                searchParam: e.target.value,
                companyId: this.props.auth.user.company.id,
                sort: "name,ASC",
                userId: 0
            };

            {
                data.companyId != undefined &&
                    getStates(data).then(response => {
                        if (!response.ok) {
                            return;
                        }
                        this.setState({
                            ...this.state,
                            states: response.data.entities,
                        });
                    });
            }
        }
        else if (e.target.name === "municipality" && e.target.value.trim().length >= 2) {
            let data = {
                searchParam: e.target.value,
                companyId: this.props.auth.user.company.id,
                sort: 'city',
                userId: 0
            };

            {
                data.companyId != undefined &&
                    getPostalCodesImproved(data).then(response => {
                        if (!response.ok) {
                            return;
                        }
                        this.setState({
                            ...this.state,
                            settlements: response.data.entities,
                        });
                    });
            }
        } else if (e.target.name === "graveyard") {
            if (!e.target.value) {
                this.setState({
                    graveSites: null,
                    data: {
                        ...this.state.data,
                        graveyard: null,
                        graveSite: null,
                        graveyardId: null,
                        graveSiteId: null,
                        expiryDate: null,
                        expiryDateString: null,
                    }
                });
                return;
            }

            this.setState({
                graveSites: null,
                data: {
                    ...this.state.data,
                    graveSite: null,
                    expiryDate: null,
                    expiryDateString: null,
                }
            });
                
            if (e.target.value.trim().length >= 2) {
                let data = {
                    searchParam: e.target.value,
                    companyId: this.props.cid,
                    sort: "name,ASC",
                    userId: 0
                };
                  
                {
                    this.props.cid != undefined &&
                    getGraveyards(data).then(response => {
                        if (!response.ok) {
                            return;
                        }
                        this.setState({
                            graveyards: response.data.entities,
                        });
                    });
                }
            }
                  
        } else if (e.target.name === "graveSite") {
            if (!e.target.value) {
                this.setState({
                    data: {
                        ...this.state.data,
                        graveSite: null,
                        graveSiteId: null
                    }
                });
                return;
            }

              this.setState({
                data: {
                  ...this.state.data
                }
              });
        
              if (e.target.value.trim().length >= 2) {
                let data = {
                  searchParam: e.target.value,
                  companyId: this.props.cid,
                  sort: "code,ASC",
                  userId: 0,
                  graveyardId: this.state.data.graveyard.id
                };
          
                this.setState({
                  typedInGraveSite: e.target.value
                });
          
                {
                  this.props.cid != undefined &&
                    getGraveSitesWithSelectedGraveyard(data).then(response => {
                      if (!response.ok) {
                        return;
                      }
                      this.setState({
                        graveSites: response.data.entities,
                        data: {
                          ...this.state.data,
                        }
                      });
                    });
                }
              }
        
        }
    }

    componentDidMount() {
        getCremationStatementById(this.props.id, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
        this.setState({
            data: response.data,
            settlements: [response.data.municipality],
            states: [response.data.state]
        }, () => {
            {
            this.state.data.graveyardId &&
                getGraveyardById(this.state.data.graveyardId, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
                    this.setState({
                        data: {
                            ...this.state.data,
                            graveyard: response.data
                        },
                        graveyards: [response.data],
                    });
                });
            }
            {
            this.state.data.graveSiteId &&
                getGraveSiteById(this.state.data.graveSiteId, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
                    this.setState({
                        data: {
                            ...this.state.data,
                            graveSite: response.data
                        },
                        graveSites: [response.data],
                    });
                })
            }
        });
        });
    }

    submit() {

        if (!this.validate()) {
            return;
        }

        this.showDrawerLoader();

        editCremationStatement(this.transformRequest(this.state.data)).then(response => {
            if (!response.ok) {
                let messageKey = response.response.data.message;

                this.props.enqueueSnackbar(strings.cremationStatement.messages[messageKey], {
                    variant: "error"
                });

                this.handleError(messageKey);

                return;
            }

            this.props.enqueueSnackbar(strings.addCompany.cremationStatementEdited, { variant: 'success' });
            this.props.onFinish(response.data.cremationStatement);

            this.hideDrawerLoader();
        });
    }

    transformRequest(data) {
        return {
            ...data,
            municipalityId: data.municipality.id,
            stateId: data.state.id,
            companyId: this.props.auth.user.company.id,
            userId: this.props.auth.user.id,
            graveyardId: data.graveyard ? data.graveyard.id : null,
            graveSiteId: data.graveSite ? data.graveSite.id : null,
        }
    }

    handleError(message) {
        // switch (message) {
        //     case "FAMOUS_CITIZEN_WITH_CODE_ALREADY_EXIST":
        //         this.setError("code", strings.famousCitizen.messages.FAMOUS_CITIZEN_WITH_CODE_ALREADY_EXIST);
        //         break;
        //     case "FAMOUS_CITIZEN_CODE_CANT_BE_NULL":
        //         this.setError("code", strings.famousCitizen.messages.FAMOUS_CITIZEN_CODE_CANT_BE_NULL);
        //         break;
        //     case "FAMOUS_CITIZEN_DESCRIPTION_CANT_BE_NULL":
        //         this.setError("description", strings.famousCitizen.messages.FAMOUS_CITIZEN_DESCRIPTION_CANT_BE_NULL);
        //         break;
        // }
    }

    render() {
        return (
            <Grid id="page" item md={12}>
                <div className="header">
                    <h1>{strings.cremationStatement.editPageTitle}</h1>
                </div>

                <Paper className="paper">
                    <CremationStatementForm
                        onChange={this.changeData}
                        onSubmit={this.submit}
                        data={this.state.data}
                        errors={this.state.errors}
                        onCancel={this.props.onCancel}
                        municipalities={this.state.settlements == undefined ? [] : this.state.settlements}
                        states={this.state.states == undefined ? [] : this.state.states}
                        onAutocompleteChange={this.onAutocompleteChange}
                        handleTextInputChange={this.handleTextInputChange}
                        graveyards={this.state.graveyards == undefined ? [] : this.state.graveyards}
                        graveSites={this.state.graveSites == undefined ? [] : this.state.graveSites}
                    />
                </Paper>

            </Grid>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            changeFullScreen: Actions.changeFullScreen
        },
        dispatch
    );
}

function mapStateToProps({ menuReducers, siteDataReducers }) {
    return { menu: menuReducers, siteData: siteDataReducers };
}

export default withSnackbar(
    withRouter(
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(EditCremationStatement)
    )
);
